import React, { useMemo } from 'react'
import { Spinner, Text } from '@shopify/polaris'
import { Doughnut } from 'react-chartjs-2'
import { beforeDraw } from '../utils/chartUtils'

const ThresholdEUSection = ({ thresholdEU, fetchingThresholdEU, t, navigate }) => {
	const total = 100

	const chartData = useMemo(() => {
		if (!thresholdEU) return null

		return {
			datasets: [
				{
					data: [
						thresholdEU.percent,
						total - (thresholdEU.percent || 0),
					],
					radius: "100%",
					cutout: 70,
					backgroundColor: ["#59C7C5", "#DAF1F2"],
					borderColor: ["#59C7C5", "#DAF1F2"],
					hoverBackgroundColor: ["#59C7C5", "#DAF1F2"],
				},
			],
		}
	}, [thresholdEU])

	const chartOptions = useMemo(() => ({
		plugins: {
			tooltip: {
				callbacks: {
					label: function (context) {
						return `${context.formattedValue}%`
					},
				},
			},
		},
	}), [])

	if (fetchingThresholdEU) {
		return <Spinner />
	}

	if (!thresholdEU) return null

	return (
		<div style={{ background: '#fff', borderRadius: 8, marginTop: 20, padding: 20, border: '1px solid rgba(227, 227, 227, 1)' }}>
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
				<h2 style={{ fontWeight: 'bold', fontSize: 18 }}>{t("home.thresholdEU")}</h2>
				<button
					style={{
						background: '#fff',
						borderColor: 'transparent',
						color: 'rgba(44, 110, 203, 1)',
						cursor: 'pointer',
						fontSize: 14,
						fontWeight: 400,
					}}
					onClick={() => navigate("/home/threshold")}
				>
					{t("home.viewAll")}
				</button>
			</div>
			<div className='dash-chart-container'>
				<Doughnut
					options={chartOptions}
					data={chartData}
					plugins={[
						{
							beforeDraw: (chart) =>
								beforeDraw(
									chart,
									thresholdEU.percent,
									thresholdEU.sum,
									Math.round(thresholdEU.threshold_sum),
									"€"
								),
						},
					]}
				/>
			</div>
		</div>
	)
}

export default ThresholdEUSection

